import { WatchQueryFetchPolicy } from '@apollo/client';
import { useMemo } from 'react';
import { Feedback } from 'v2/core/entities/feedback';
import { useGetRecordFromEdgeServer } from 'v2/core/repository/edge-server/records';
import { QueryStatus } from 'v2/core/repository/edge-server/types';
import { updateFeedbacks } from 'v2/core/services/records/updateFeedback';
import { useGetUser } from 'v2/core/services/user';

const useGetFeedback = (
  recordId: string,
  fetchPolicy?: WatchQueryFetchPolicy,
) => {
  const {
    tenant: { timezone, id: tenantID },
  } = useGetUser();

  const {
    data: rawFeedback,
    status: rStatus,
    error,
  } = useGetRecordFromEdgeServer({
    tenantID,
    recordID: recordId,
    timezone,
    fetchPolicy,
  });

  const feedback = useMemo(() => {
    return updateFeedbacks(rawFeedback)?.[0];
  }, [rawFeedback]);

  return {
    feedback,
    error,
    status: rStatus,
  };
};
export interface FeedbackResponses {
  feedbacks: Feedback[] | undefined;
  fetchMore: () => Promise<void>;
  hits: number | undefined;
  error: Error | undefined;
  status: QueryStatus;
  isLoadingMore: boolean;
  refetch?: () => Promise<any>;
}

export { useGetFeedback };
